// extracted by mini-css-extract-plugin
export default {"section":"FeedBacks_section__p+yJj","description":"FeedBacks_description__U0B+O","name":"FeedBacks_name__KXGas","stars":"FeedBacks_stars__pxe4W","button":"FeedBacks_button__EzYKH"};